import { render, staticRenderFns } from "./languageForm.vue?vue&type=template&id=4c7ea45e"
import script from "./languageForm.vue?vue&type=script&lang=js"
export * from "./languageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports